<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import "animate.css";

export default {
  name: "App",

  mounted() {},
};
</script>
<style>
   
html,
body {
  height: 100%;
}
.flex_center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex_start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flex_end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.flex_between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.absolute {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.relative {
  position: relative;
}
.one_line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
* {
  /* font-family: Source Han Sans CN; */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
    Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji !important;
}
.model__wrap {
  .ant-modal-confirm .ant-modal-body {
    padding: 0;
  }
  .ant-modal-confirm-btns {
    display: none;
  }
  .ant-modal-confirm-body .ant-modal-confirm-content {
    margin-top: 0;
  }
  .ant-modal-body{
    padding: 0;
  }
}
html {
  overflow: hidden;
}
body {
  overflow: hidden;
}
</style>
